import React from 'react'

import store from './store'

import { Provider } from 'react-redux'
import { Router, Route, IndexRoute } from 'react-router'
import { createHashHistory } from 'history'
import { syncHistoryWithStore } from 'react-router-redux'

import App from './containers/App/'
import Profile from 'containers/Profile'
import CompanyProfile from 'containers/CompanyProfile'

import Faturation from 'containers/Faturation'
import Consume from 'containers/Consume'
import Results from 'containers/Results'

const basedBrowserHistory = createHashHistory({})
export const history = syncHistoryWithStore(basedBrowserHistory, store)

export const AdvancedRoutes = () => {
  const Habitation = require('containers/Habitation').default
  return (
    <Provider store={store}>
      <Router history={history}>
        <Route path='/' component={App}>
          <IndexRoute component={Profile} />
          <Route path='/habitacao' component={Habitation} />
          <Route path='/faturacao' component={Faturation} />
          <Route path='/consumos' component={Consume} />
          <Route path='/resultados' component={Results} />
        </Route>
      </Router>
    </Provider>
  )
}

export const SimpleRoutes = () => {
  const SimpleHabitation = require('containers/SimpleHabitation').default
  return (
    <Provider store={store}>
      <Router history={history}>
        <Route path='/' component={App}>
          <IndexRoute component={Profile} />
          <Route path='/habitacao' component={SimpleHabitation} />
          <Route path='/faturacao' component={Faturation} />
          <Route path='/resultados' component={Results} />
        </Route>
      </Router>
    </Provider>
  )
}

export const EnterpriseRoutes = () => {
  return (
    <Provider store={store}>
      <Router history={history}>
        <Route path='/' component={App}>
          <IndexRoute component={CompanyProfile} />
          <Route path='/faturacao' component={Faturation} />
          <Route path='/consumos' component={Consume} />
          <Route path='/resultados' component={Results} />
        </Route>
      </Router>
    </Provider>
  )
}



// WEBPACK FOOTER //
// ./src/routes.js